import { render, staticRenderFns } from "./ModalVisaTypeNew.vue?vue&type=template&id=78180d71&"
import script from "./ModalVisaTypeNew.vue?vue&type=script&lang=js&"
export * from "./ModalVisaTypeNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports